var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"exhibit__SpecialCardContainer"},_vm._l((_vm.exhibitLists),function(exhibit,index){return _c('ExhibitCardSpecial',{key:index,attrs:{"index":index,"exhibit":exhibit,"onlyImage":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }